import { z } from 'zod';
import { equipmentStatusEnum } from './enums.ts';

export const createEquipmentInput = z.object({
  name: z.string().min(1).max(120),
  category: z.string().min(1).max(64),
  brand: z.string().max(64).nullable().optional(),
  model: z.string().max(64).nullable().optional(),
  serialNumber: z.string().max(128).nullable().optional(),
  purchaseDate: z.string().nullable().optional(),
  storageZoneId: z.string().nullable().optional(),
  notes: z.string().max(8000).nullable().optional(),
  status: equipmentStatusEnum.optional(),
});
export type CreateEquipmentInput = z.infer<typeof createEquipmentInput>;

export const patchEquipmentInput = createEquipmentInput.partial();
export type PatchEquipmentInput = z.infer<typeof patchEquipmentInput>;

export const createEquipmentPartInput = z.object({
  partName: z.string().min(1).max(120),
  partNumber: z.string().max(128).nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export type CreateEquipmentPartInput = z.infer<typeof createEquipmentPartInput>;

export const patchEquipmentPartInput = createEquipmentPartInput.partial();
export type PatchEquipmentPartInput = z.infer<typeof patchEquipmentPartInput>;
